module.exports = __webpack_public_path__ + "static/img/main_notification_icon_g.ed19489f.svg";